import React from 'react';

import HeroHeader from '../components/HeroHeader';
import WineList from '../components/WineList';

const Home = () => {
  return (
    <>
      <HeroHeader />
      <WineList />
    </>
  );
};
export default Home;
